import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {User} from "../models";
import {ApiService} from "../services/api.service";

@Injectable()
export class ResourceService {

  constructor(private api: ApiService) {}

  public getMvkReshIdBySubjectId(subjectId: string): Observable<any> {
    return this.api.get(`/api/v1/qref/mvk/resh/${subjectId}`);
  }

  public getMsLead(id: string): Observable<any> {
    return this.api.get("/api/v1/qref/mslead/" + id);
  }

  public getMsFound(id: string): Observable<any> {
    return this.api.get("/api/v1/qref/msfound/" + id);
  }

  public getFts(id: string): Observable<any> {
    return this.api.get("/api/v1/qref/fts/" + id);
  }
  
  public getRiskGroup(id: string): Observable<any> {
    return this.api.get("/api/v1/cls/kyc/" + id);
  }

  public getMsAdr(id: string): Observable<any> {
    return this.api.get("/api/v1/qref/msadr/" + id);
  }

  public getPassport(id: string): Observable<any> {
    return this.api.get("/api/v1/qref/passport/" + id);
  }

  public getPassportInfo(params: any): Observable<any> {
    return this.api.get("/api/v1/qref/passport/entries", params, 'id');
  }

  public getMassFoundInfo(params: any): Observable<any> {
    return this.api.get("/api/v1/qref/msfound/entries", params, 'id');
  }

  public getMassLeadInfo(params: any): Observable<any> {
    return this.api.get("/api/v1/qref/mslead/entries", params, 'id');
  }

  public getMassAdrInfo(params: any): Observable<any> {
    return this.api.get("/api/v1/qref/msadr/entries", params, 'id');
  }

  public getFtsInfo(params: any): Observable<any> {
    return this.api.get("/api/v1/qref/fts/entries", params, 'id');
  }

  public getRiskGroupInfo(params: any): Observable<any> {
    return this.api.get("/api/v1/cls/kyc/info/", params, 'id');
  }
  
  public getBounceInfoList(params: any): Observable<any> {
    return this.api.get('/api/v1/cls/refusal/accepted/', params, 'id');
  }

  public getFromuInfoList(params: any): Observable<any> {
    return this.api.get('/api/v1/qref/fromu/info', params, 'id');
  }

  public getMvkInfoList(params: any): Observable<any> {
    return this.api.get('/api/v1/qref/mvk/info', params, 'id');
  }

  /**
   * Получить список файлов террористов
   */
  public getTerroristFiles(params: object): Observable<any> {
    return this.api.get("/api/v1/qref/terror/info/full", params, 'id');
  }

  /**
   * Получение списка пользователей
   */
  public getUserAdminList(params: any): Observable<any> {
    return this.api.get("/api/v1/authad/users", params);
  }
  /**
   * Получение списка пользователей для фильтрации
   */
  public getUserList(params: any): Observable<any> {
    return this.api.get("/api/v1/authad/users", params);
  }

  /**
   * Получение списка незаблокированных пользователей, имеющих доступ к досье
   */
  public getDocsaccessUserList(params: any): Observable<any> {
    return this.api.get("/api/v1/docsaccess/users", params);
  }

  /**
   * Получение списка пользователей, которые назначены для указанных досье, включая заблокированных.
   */
  public getDocsaccessDocsUserList(dossierIds: []): Observable<any> {
    return this.api.post("/api/v1/docsaccess/documents/users", dossierIds);
  }

  /**
   * Получить список событий
   */
  public getEventList(params: any): Observable<any> {
    return this.api.get("/api/v1/audit/events", params);
  }

  /**
   * Получить список пользователей по заданным разрешениям
  */
 public getUsersByPermissions(params: String[]): Observable<User[]> {
   return this.api.post("/api/v1/authad/users/permission", params);
 }

 /**
   * Получить список пользователей, имеющих доступ к досье
  */
 public getUsersByDossierId(dossierId: string): Observable<User[]> {
   return this.api.get(`/api/v1/docsaccess/permission/${dossierId}`);
 }

  /**
   * Получить список пользователей, имеющих доступ к результату проверки
   */
  public getUsersByCheckClient(checkClientId: string): Observable<User[]> {
    return this.api.get(`/api/v1/check/client/usersAccess/${checkClientId}`);
  }

  /**
   * Получить список пользователей, имеющих доступ к результату анализа операции
   */
  public getUsersByTransactionCheck(transactionCheckId: string): Observable<User[]> {
    return this.api.get(`/api/v1/transaction/check/usersAccess/${transactionCheckId}`);
  }

  /**
   * Получить список пользователей, имеющих доступ к оповещению
   */
  public getUsersByNoticeId(noticeId: string): Observable<User[]> {
    return this.api.get(`/api/v1/notices/permission/${noticeId}`);
  }
}
